import { Grid } from '@mui/material';
import { useEffect, useState } from 'react';
import { Outlet, useLoaderData } from 'react-router';

import useAppContext from '../../hooks/useAppContext';

import type { Organization } from '@/types/organization';

const OrganizationDetails = () => {
  const loaderOrganization: Organization = useLoaderData();
  const [organization, setOrganization] = useState<Organization>(loaderOrganization);
  const contextState = useAppContext();

  useEffect(() => {
    contextState.setSelectedOrganization?.(loaderOrganization);
  }, [loaderOrganization, contextState]);

  return (
    <Grid
      container
      className='content-with-header'
      direction='column'
    >
      <Grid item>
        <Grid
          container
          justifyContent='space-between'
        >
          <Grid
            item
            xs={14}
          >
            <Outlet context={[organization, setOrganization]} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default OrganizationDetails;
